module.exports = __webpack_public_path__ + "static/media/gift-ticket-icon.b3e5fb0b.png";